import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export function NoMatch() {
  const location = useLocation();
  const isApi = location.pathname.startsWith('/api/');

  useEffect(() => {
    if (isApi) {
      window.location.replace(
        location.pathname + location.search + location.hash,
      );
    }
  }, [isApi, location.pathname, location.search, location.hash]);

  if (isApi) {
    return <div className="muted">Loading file…</div>;
  }
  return (
    <div className="card">
      <h2 style={{ marginTop: 0 }}>Page not found</h2>
      <p className="muted">No route matches <code>{location.pathname}</code>.</p>
      <Link to="/" className="btn">Back home</Link>
    </div>
  );
}
